/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterMatchingDoctorDto } from '../../models/filter-matching-doctor-dto';
import { FilterResponseMatchingDoctorDto } from '../../models/filter-response-matching-doctor-dto';

export interface DoctorMatchingControllerFindMatchingDoctor$Params {
      body: FilterMatchingDoctorDto
}

export function doctorMatchingControllerFindMatchingDoctor(http: HttpClient, rootUrl: string, params: DoctorMatchingControllerFindMatchingDoctor$Params, context?: HttpContext): Observable<StrictHttpResponse<FilterResponseMatchingDoctorDto>> {
  const rb = new RequestBuilder(rootUrl, doctorMatchingControllerFindMatchingDoctor.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FilterResponseMatchingDoctorDto>;
    })
  );
}

doctorMatchingControllerFindMatchingDoctor.PATH = '/thalea-match/doctor-matching/filter';
